import { type Theme, useMediaQuery } from '@mui/material';

const COMPACT_ACTIONS_MAX_WIDTH_PX = 1054;
const NARROW_ACTIONS_MAX_WIDTH_PX = 400;

export function useReportHeaderActionLayout() {
  const isCompactActions = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(COMPACT_ACTIONS_MAX_WIDTH_PX),
  );
  const isSmallScreen = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm'),
  );
  const isNarrowActions = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down(NARROW_ACTIONS_MAX_WIDTH_PX),
  );

  return {
    isCompactActions,
    isSmallScreen,
    isNarrowActions,
  } as const;
}
